import { createSelector } from '@reduxjs/toolkit';
import { combineSmsMessagesIntoThreads } from '../services/smsService';
import { StoreState } from '../store';

export const smsMessagesSelector = createSelector(
  [(state: StoreState) => state.sms.smsMessages],
  (smsMessages) =>
    smsMessages.map((m) => ({
      ...m,
      to: m.to.startsWith('44') ? '0' + m.to.substring(2) : m.to,
      from: m.from.startsWith('44') ? '0' + m.from.substring(2) : m.from,
    })),
);

export const smsThreadsByNumberSelector = createSelector(
  [smsMessagesSelector],
  (smsMessages) => combineSmsMessagesIntoThreads(smsMessages),
);
